import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "antd";
import Heading from "./Heading";
import InfoBlock from "./InfoBlock";
import AllocationTable from "./AllocationTable";
import { InfoTitle, BoxDetailWrapperPrint } from "../style";
import {
  getAllocationPreference,
  renderAgreementPayment,
  renderRecurringPayment,
} from "./Step2Summary";

const renderOneTimeSummary = ({
  allSharesAllPoolsType,
  allSharesType,
  paymentType,
  startDate,
  amountString,
}) => {
  let paymentTitle = "Total Payment";
  if (allSharesAllPoolsType || allSharesType) {
    paymentTitle = "Approximate Grant Amount*";
  }
  return (
    <>
      <BoxDetailWrapperPrint border>
        <InfoBlock title="Payment" value={paymentType} />
      </BoxDetailWrapperPrint>
      {startDate && (
        <BoxDetailWrapperPrint border>
          <InfoBlock title="Scheduled Issue Date" value={startDate} />
        </BoxDetailWrapperPrint>
      )}
      <BoxDetailWrapperPrint>
        <InfoBlock title={paymentTitle} value={amountString} />
        {(allSharesAllPoolsType || allSharesType) && (
          <InfoTitle>
            *Underlying investment values change each day, so this amount is
            subject to change.
          </InfoTitle>
        )}
      </BoxDetailWrapperPrint>
    </>
  );
};

const renderRecurringSummary = ({
  grantAgreement,
  grantAgreementAmount,
  paymentType,
  frequency,
  startDate,
  endDate,
  amountString,
}) => {
  return (
    <>
      <BoxDetailWrapperPrint border>
        {grantAgreement
          ? renderAgreementPayment(grantAgreementAmount)
          : renderRecurringPayment(paymentType, frequency)}
      </BoxDetailWrapperPrint>
      <BoxDetailWrapperPrint border>
        <Row type="flex">
          <Col span={12}>
            <InfoBlock title="Start Date" value={startDate} />
          </Col>
          <Col span={11} offset={1}>
            <InfoBlock title="End Date" value={endDate} />
          </Col>
        </Row>
      </BoxDetailWrapperPrint>
      <BoxDetailWrapperPrint>
        <InfoBlock title="Total Number of Payments" value={amountString} />
      </BoxDetailWrapperPrint>
    </>
  );
};


/**
 * Components layout is complicated because of the design requirements
 *
 */
export default function Step2SummaryPrint({
  title,
  edit,
  handleEdit,
  recurring = false,
  paymentType,
  startDate,
  endDate,
  frequency,
  amountString,
  allocationType,
  allocations,
  grantAgreement = false,
  grantAgreementAmount,
  allSharesAllPools = false,
  allShares = false,
}) {
  return (
    <>
      <Heading title={title} edit={edit} handleEdit={handleEdit} />
      <Row type="flex">
        <Col lg={8} span={24}>
          {recurring
            ? renderRecurringSummary({
                grantAgreement,
                grantAgreementAmount,
                paymentType,
                frequency,
                startDate,
                endDate,
                amountString,
              })
            : renderOneTimeSummary({ paymentType, startDate, amountString })}
        </Col>
        <Col lg={{ span: 14, offset: 2 }} span={24}>
          <BoxDetailWrapperPrint border>
            <InfoBlock
              border
              title="Allocation Preference"
              value={getAllocationPreference(
                allocationType,
                allSharesAllPools,
                allShares
              )}
            />
          </BoxDetailWrapperPrint>
          <AllocationTable
            allocations={allocations}
            allShares={allShares}
            allSharesAllPools={allSharesAllPools}
          />
        </Col>
      </Row>
    </>
  );
}

Step2SummaryPrint.propTypes = {
  title: PropTypes.string,
  edit: PropTypes.bool,
  handleEdit: PropTypes.func,
  recurring: PropTypes.bool,
  paymentType: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  frequency: PropTypes.string,
  amountString: PropTypes.string,
  allocationType: PropTypes.string,
  allocations: PropTypes.arrayOf(
    PropTypes.shape({
      allShare: PropTypes.bool,
      grantAmount: PropTypes.string,
      grantPercentage: PropTypes.number,
      id: PropTypes.number,
      name: PropTypes.string,
      units: PropTypes.number,
    })
  ),
  grantAgreement: PropTypes.bool,
  grantAgreementAmount: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  allSharesAllPools: PropTypes.bool,
  allShares: PropTypes.bool,
};
